import { render } from "./TenValue.vue?vue&type=template&id=003d3b1e&ts=true"
import script from "./TenValue.vue?vue&type=script&lang=ts"
export * from "./TenValue.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/daiwei/Documents/Dodoca/guinong/guinong-official-website/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__